import { ReducerBuilder } from 'typescript-fsa-reducers';

import { applyAsyncReducer } from '@utils';

import { targetsFetchCurrent } from './targetsFetchCurrent';

import { ITargetsStore } from '../../types';
import { IActionTargetsFetchCurrentPayloadDone } from './types';

export const targetsFetchCurrentReducer = (projects: ReducerBuilder<ITargetsStore, ITargetsStore>) => {
	applyAsyncReducer<ITargetsStore['currentTarget']['data'], ITargetsStore['currentTarget']['meta']>()(
		'currentTarget',
		'networkStatus',
		targetsFetchCurrent.async,
		projects,
		(props: { result: IActionTargetsFetchCurrentPayloadDone }) => ({
			target: props.result.target,
			plan: props.result.plan,
		}),
	);
};
